<template>
	<GoalSubHeaderLayout class="goal-sub-header">
		<template #team-name>
			<label class="stack-label">{{ translate( "teamLabel" ) }}</label>
			<h6 class="stack-value">{{ teamName }}</h6>
		</template>
		<template #due-date>
			<label class="stack-label">{{ translate( "dueLabel" ) }}</label>
			<h6 class="stack-value">{{ shortDueDate }}</h6>
		</template>
		<template #last-updated>
			<label class="stack-label">{{ translate( "lastUpdatedLabel" ) }}</label>
			<h6 class="stack-value">{{ lastUpdatedAgo }}</h6>
		</template>
		<template #confidence-level>
			<label class="stack-label">{{ translate( "confidenceLabel" ) }}</label>
			<div>
				<ConfidenceChip
					style="display: inline-flex;"
					:level="confidenceLevel"
					:disabled="true"
				/>
			</div>
		</template>
		<template #progress>
			<label class="stack-label">{{ translate( "progressAndPacingLabel" ) }}</label>
			<div class="progress-stack-value stack-value">
				<div>{{ progress }}%</div>
				<TeamingProgressBar
					class="progress-bar"
					:percent-completed="progress"
					:percent-progressed="pacing"
					:show-percent="false"
				/>
			</div>
		</template>
	</GoalSubHeaderLayout>
</template>

<script>
import { DateTime } from "luxon";

import { ConfidenceLevel } from "@teaming/common-enums";

import {
	TeamingProgressBar,
	ConfidenceChip
} from "@teaming/common-ui";

import GoalSubHeaderLayout from "./GoalSubHeaderLayout";

export default {
	name: "GoalSubHeader",
	emits: [ "back", ],
	components: {
		GoalSubHeaderLayout,
		TeamingProgressBar,
		ConfidenceChip,
	},
	props: {
		teamName: {
			type: String,
			required: true,
		},
		dueDate: {
			type: String,
			required: true,
		},
		lastUpdatedDate: {
			type: String,
			required: true,
		},
		confidenceLevel: {
			type: String,
			required: true,
			validator( value ) {
				return ConfidenceLevel.includes( value );
			},
		},
		progress: {
			type: Number,
			required: true,
		},
		pacing: {
			type: Number,
			required: true,
		},
	},
	computed: {
		shortDueDate() {
			return DateTime.fromFormat( this.dueDate, "MM/dd/yyyy" )
				.toFormat( "MMM d" ); // e.g. "Sep 30"
		},
		lastUpdatedAgo() {
			return DateTime.fromISO( this.lastUpdatedDate )
				.toRelative(); // e.g. "16 hours ago"
		},
	},
	methods: {
		translate( key, args = {} ) {
			return this.$t( `common-gokr.components.GoalSubHeader.${ key }`, args );
		},
	},
};
</script>

<style lang="scss" scoped>
$goalSubHeaderLabelColor: $color1-500;
$goalSubHeaderTextColor: $color1-700;
$goalSubHeaderProgressColor: $color2-500;

.goal-sub-header .progress-bar {
	width: 100%;
}

.goal-sub-header .stack-label {
	@include font-and-line-for(-1);
	font-weight: 600;
	color: $goalSubHeaderLabelColor;
	text-align: left;
}

.goal-sub-header .stack-value {
	@include font-and-line-for(0);
	font-weight: 600;
	color: $goalSubHeaderTextColor;
	text-align: left;
}

.goal-sub-header .progress-stack-value {
	display: flex;
	flex-direction: row;
	gap: 0.5rem;

	color: $goalSubHeaderProgressColor;
}
</style>
